import Location from "./location.component";

const LocationList = ({locations, isLoading, kind, favorites}) => {
  return isLoading ? 
          <p>Loading</p> : 
          locations.map((location) => <Location key={kind+location.ID} favorites={favorites} location={location} kind={kind}/>)
}

export default LocationList;